export default __webpack_public_path__ + "static/invoicing-automation-894643729b26d403e23bdcf8963a652c.png";